/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */

import {
  GET_ASSET_BASIC_INFO,
  GET_ASSET_BASIC_INFO_SUCCESS,
  GET_ASSET_BASIC_INFO_FAILURE,
  UPDATE_ASSET_BASIC_INFO,
  UPDATE_ASSET_BASIC_INFO_SUCCESS,
  UPDATE_ASSET_BASIC_INFO_FAILURE,
  RESET_BASIC_INFO,
} from "../actions/actionTypes";

import {
  setLoadingState,
  setSuccessResponse,
  setErrorResponse,
} from "./reducerUtils";

const initialState = {
  data: null,
  state: "INIT",
  error: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ASSET_BASIC_INFO:
      return setLoadingState(state, "", "GET");

    case GET_ASSET_BASIC_INFO_SUCCESS:
      return setSuccessResponse(state, action, "", "GET");

    case GET_ASSET_BASIC_INFO_FAILURE:
      return setErrorResponse(state, action.err, "", "GET");

    case UPDATE_ASSET_BASIC_INFO:
      return setLoadingState(state, "", "UPDATE");

    case UPDATE_ASSET_BASIC_INFO_SUCCESS:
      return setSuccessResponse(state, action, "", "UPDATE");

    case UPDATE_ASSET_BASIC_INFO_FAILURE:
      return setErrorResponse(state, action.err, "", "UPDATE");

    case "UPDATE_DEAL_RECORD":
      return {
        basicInfo: {
          ...state.basicInfo,
          showAsDeal: action.payload.showAsDeal,
          dealType: action.payload.dealType,
        },
        loadingBasicInfoSuccess: true,
      };
    case "UPDATE_TRANSFER_RECORD":
      return {
        basicInfo: {
          ...state.basicInfo,
          transferredType: action.payload.transferDeal.transferredType,
          showAsDeal: action.payload.transferDeal.showAsDeal,
        },
        loadingBasicInfoSuccess: true,
      };
    case RESET_BASIC_INFO:
      return {};
    default:
      return state;
  }
}
